// Profile.tsx (Hardcoded Version)

import {
    Card,
    Grid,
    Box,
    Typography,
    Tabs,
    Tab,
    Chip,
    Stepper,
    Step,
    StepLabel,
    useMediaQuery,
    useTheme,
    Modal,
    Button,
    Avatar,
    Stack,
    CardContent,
    List,
    ListItemText,
    ListItem,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Divider,
    Snackbar,
    Alert,
 SnackbarCloseReason } from '@mui/material';
import { styled } from '@mui/system';
import CakeIcon from '@mui/icons-material/Cake';
import ProfileImg from '../../Assets/profileImg.png';
import React, { useEffect, useState } from 'react';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ProgramImg from '../../Assets/programImg.png';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { makeStyles } from '@mui/styles';

import ModeEditIcon from '@mui/icons-material/ModeEdit';

import { Theme } from '@mui/material';
import { getStudentGoalsAPI, studentAcademicSchedule, studentsAcademicPlan, sudentsDataList } from '../../../../Utils/apiService';
import ExtraCurricular from './Components/ExtraCurricular';
import Achievements from './Components/Achievements';
import AboutMe from './Components/AboutMe';
import { getUserDetails } from '../../../../storageService';
import GoalCardStudent from '../../../../GlobalComponents/GoalCards/GoalCardStudent';
import { useNavigate } from 'react-router-dom';
import CallIcon from '@mui/icons-material/Call';
import KenLoader from '../../../../GlobalComponents/KenLoader';

const useStyles = makeStyles((theme: Theme) => ({
    profileCard: {
        borderRadius: '6px !important',
        padding: '15px',
        boxShadow: 'none !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
        },
    },
    scheduleContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    dayTabs: {
        display: 'flex',
        gap: '4px',
        marginBottom: '16px'
    },
    dayTab: {
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s',
        border: 'none',
        background: '#EDEEF1',
        color: '#64748B'
    },
    activeDayTab: {
        backgroundColor: '#1E293B !important',
        color: 'white !important'
    },
    scheduleTable: {
        '& .MuiTableCell-root': {
            border: 'none',
            padding: '12px 16px',
            fontSize: '14px',
            borderBottom: '1px solid #F1F5F9',
            color: '#585A64'
        },
        '& .MuiTableHead-root .MuiTableCell-root': {
            fontWeight: '600',
            color: '#172E7D',
            // backgroundColor: '#F8FAFC',
            borderBottom: '1px solid #E2E8F0',
            fontSize: '13px'
        },
        '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
            borderBottom: 'none'
        }
    },
    scheduleRow: {
        '&:hover': {
            backgroundColor: '#F8FAFC'
        }
    },
    periodCell: {
        color: '#64748B',
        fontWeight: '500',
        fontSize: '14px'
    },
    subjectCell: {
        color: '#1E293B',
        fontWeight: '500',
        fontSize: '14px'
    },
    roomCell: {
        color: '#64748B',
        fontSize: '14px'
    },
    timeCell: {
        color: '#64748B',
        fontSize: '14px'
    },
    postJobBtns: {
        width: '45%',
        height: '30px !important',
        borderRadius: '9px !important',
        marginTop: '10px !important',
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        textAlign: 'center',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            width: '45%',
            height: '26px !important',
        },
    },

    profileBox: {
        backgroundColor: '#EAEFFF !important',
        borderRadius: '6px !important',
        padding: '10px !important',
        marginTop: '20px !important',
    },
    verticalLine: {
        width: '1px',
        height: '100px',
        backgroundColor: '#E5E6EA',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '100px',
        },
    },
    profileName: {
        fontSize: '15px !important',
        textAlign: 'left',
        marginTop: '20px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '12px !important',
        },
    },
    profileBoxTitle: {
        fontSize: '16px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '16px !important',
        },
    },
    profileBoxContent: {
        fontSize: '12px !important',
        textAlign: 'left',
        fontWeight: '400 !important',
        marginTop: '5px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
        },
    },
    table: {
        width: '100% !important',
    },
    th: {
        color: '#172E7D !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        textAlign: 'left',
        padding: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },

    td: {
        fontSize: '12px !important',
        fontWeight: '400 !important',
        textAlign: 'left',
        padding: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    tableHeader: {
        position: 'sticky',
        top: 0,
        backgroundColor: '#F6F8FB !important',
        borderBottom: '0.5px solid #B2B3B7 !important',
        zIndex: 1, // ensure it's above the rest
    },
    tableHeaderA: {
        position: 'sticky',
        top: 0,
        backgroundColor: '#EAEFFF !important',
        borderBottom: '0.5px solid #B2B3B7 !important',
        zIndex: 1, // ensure it's above the rest
    },
    tableRow1: {
        backgroundColor: '#F6F8FB !important',
    },
    tableRowA: {
        backgroundColor: '#fff !important',
    },
    extraCuricularBox: {
        backgroundColor: '#F6F8FB !important',
        borderRadius: '12px !important',
        padding: '10px !important',
        height: '49.3vh !important',
        '@media (min-width: 1440px) and (max-width: 1500px)': {
            height: '52vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 1940px)': {
            height: '54vh !important',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
            height: '43.8vh !important',
        },
    },
    extraCuricularBox2: {
        borderRadius: '12px !important',
        height: '49.3vh !important',
        '@media (min-width: 1440px) and (max-width: 1500px)': {
            height: '52vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 1940px)': {
            height: '54vh !important',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
            height: '43.8vh !important',
        },
    },
    extraCuricularBox1: {
        backgroundColor: '#F6F8FB !important',
        borderRadius: '12px !important',
        padding: '15px !important',
        height: '49.3vh !important',
        '@media (min-width: 1440px) and (max-width: 1500px)': {
            height: '52vh !important',
        },
        '@media (min-width: 1920px) and (max-width: 1940px)': {
            height: '54vh !important',
        },
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            padding: '10px !important',
            height: '43.8vh !important',
        },
    },
    categoriesBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '5px !important',
        marginTop: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            marginTop: '5px !important',
            padding: '5px !important',
        },
    },
    categoriesBox1: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '5px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            marginTop: '5px !important',
            padding: '5px !important',
        },
    },
    categoriesTitle: {
        fontSize: '15px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '12px !important',
        },
    },
    categoriesBtns: {
        width: '100%',
        height: '36px !important',
        borderRadius: '8px !important',
        background: '#EAEFFF !important',
        borderShadow: 'none !important',
        color: "#5981FF !important",
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            height: '26px !important',
            width: '10%',
        },
    },
    categoryBtns: {
        width: '13%',
        height: '36px !important',
        borderRadius: '9px !important',
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            height: '26px !important',
            width: '10%',
        },
    },
    clubsBox: {
        backgroundColor: '#FFFFFF !important',
        borderRadius: '12px !important',
        padding: '16px !important',
        border: '0.5px solid #BFCEFF',
        marginTop: '10px !important',
    },
    clubsTitle: {
        fontSize: '14px !important',
        textAlign: 'left',
        fontWeight: '500 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    clubsContent: {
        fontSize: '12px !important',
        textAlign: 'left',
        fontWeight: '400 !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
        },
    },
    certificateBtns: {
        width: '100%',
        height: '36px !important',
        borderRadius: '9px !important',
        padding: '9px !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        marginTop: '10px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '10px !important',
            padding: '5px !important',
            height: '26px !important',
        },
    },
    tableContainer: {
        border: '2px solid #E5E6EA',
        borderRadius: 10,
    },
    dilogHeader: {
        fontSize: '15px !important',
        fontWeight: '500 !important',
        marginBottom: '12px !important',
        borderBottom: '1px solid #BFCEFF',
        paddingBottom: '10px',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '13px !important',
        },
    },
    dilogtypo: {
        fontSize: '12px !important',
        fontWeight: '500 !important',
        marginBottom: '8px !important',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px !important',
        },
    },
    customSelect: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: '0.5px solid #B2B3B7 !important',
            padding: '0px 12px !important',
            borderRadius: '6px !important',
        },
        '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select': {
            padding: '10px !important',
        },
        '& .MuiInputBase-input': {
            fontSize: '12px',
        },
        '& .MuiOutlinedInput-root': {
            height: '36px',
        },
    },
    customTextArea: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: '0.5px solid #B2B3B7 !important',
            padding: '0px 12px !important',
            borderRadius: '6px !important',
        },
        '& .MuiInputBase-input': {
            fontSize: '12px',
        },
    },
    customText: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: '0.5px solid #B2B3B7 !important',
            padding: '0px 12px !important',
            borderRadius: '6px !important',
        },
        '& .MuiInputBase-input': {
            fontSize: '12px',
        },
        '& .MuiOutlinedInput-root': {
            height: '36px',
        },
        '& .MuiInputBase-input.MuiOutlinedInput-input': {
            padding: '10px !important',
        },
    },
    profileButton: {
        borderRadius: '6px !important',
        boxShadow: 'none !important',
        height: '36px !important',
    },
    programsTitle: {
        fontSize: '14px !important',
        fontWeight: '500 !important',
        textAlign: 'left',
    },
    programsContent: {
        fontSize: '11px !important',
        fontWeight: '600 !important',
        textAlign: 'left',
    },
    programsScore: {
        color: '#2C58E8 !important',
        fontSize: '12px !important',
        fontWeight: '500 !important',
        textAlign: 'left',
    },
    programBox: {
        border: '1px solid #E9E9ED',
        borderRadius: '12px !important',
        padding: '12px !important',
    },
    AddButton: {
        background: 'linear-gradient(90deg, #3061FF -15.54%, #30C1FF 133.56%)',
        color: '#FFFFFF !important',
        borderRadius: '8px !important',
    }
}));

const categoriesData = [
    { title: 'Clubs' },
    { title: 'Sports' },
    { title: 'Social work' },
    { title: 'Academics' },
    { title: 'Conferences, Conclaves & Seminars' },
];

const semesterData = [
    { title: 'Grade 9 (2024- 25)' },
    { title: 'Grade 10 (2025- 26)' },
    { title: 'Grade 11 (2026- 27)' },
    { title: 'Grade 9 (2027- 28)' },
];

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


type Goal = {
    Id?: any
    title?: string;
    desc?: string;
    description?: string;
    type?: 'Group' | 'Individual' | string;
    progress?: { done: number; total: number } | null;
    status?: any;
};


const MyStudentTabPanel = (props: any) => {
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [categoriesValue, setCategoriesValue] = useState('Clubs');
    const [semesterValue, setSemesterValue] = useState('Semester I');
    const [academicsData, setAcademicsData] = useState<any>([])
    const [activeStep, setActiveStep] = useState(0);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [activeDay, setActiveDay] = useState<string>('Monday');
    const [open, setOpen] = useState(false);
    const [openAchieve, setOpenAchieve] = useState(false);
    const [openID, setOpenID] = useState(false);
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState(false);
    const [valueSemester, setValueSemester] = useState<any>([])
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleOpenAchieve = () => setOpenAchieve(true);
    const handleCloseAchieve = () => setOpenAchieve(false);
    const handleOpenID = () => setOpenID(true);
    const handleCloseID = () => setOpenID(false);
    const [scheduleData, setScheduleData] = useState<any>({
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Sunday: []
    });
    const [selectedDay, setSelectedDay] = useState<DayOfWeek>('Monday');
    const navigate = useNavigate();

    const userDetails = getUserDetails();
    const userType = userDetails?.Type || '';
    const contactId = userDetails?.ContactId || '';
    const url = window.location.pathname;
    const segments = url.split('/');
    const studentId = segments[segments.length - 1];
    const [myGoals, setMyGoals] = useState<Goal[]>([]);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleSemesterData = (val: any) => {
        const transformed = val.courses
            .filter((course: any) => course.termGrades.length > 0)
            .map((course: any) => {
                const gradeInfo: any = course.termGrades[0];
                const quarters: any = gradeInfo.quarterGrades.reduce((acc: any, q: any) => {
                    acc[q.quarterName] = q.grade;
                    return acc;
                }, {} as Record<string, string>);

                const data = {
                    courseName: course?.courseName,
                    credits: course?.credits,
                    GPA: course?.GPA,
                    ...quarters,
                    percentGrade: gradeInfo?.percentGrade,
                    numericalGrade: gradeInfo?.numericalGrade
                };

                return {
                    label: course.courseName,  // Key for MUI table label
                    value: data                // Data to be rendered in table
                };
            });

        setAcademicsData(transformed); // You can keep this as needed
    };


    // Callback function to handle data updates from child components
    const handleDataUpdate = (updatedData: any) => {
        // Only update specific parts of the data that are related to achievements/extracurricular
        // Don't update the main data array structure
        if (updatedData?.achievements || updatedData?.club) {
            // Update only the achievements and club data in props
            if (props?.data && !Array.isArray(props.data)) {
                props.data = {
                    ...props.data,
                    achievements: updatedData.achievements || props.data.achievements,
                    club: updatedData.club || props.data.club
                };
            }
        }
    };

    useEffect(() => {
        const contactId = userType === "Student" ? userDetails?.ContactId : studentId
        studentsAcademicPlan(contactId).then((res) => {
            console.log(res, "xsdssdfnj");
            let response = res.data;
            setData(response)
            handleSemesterData(response[0])
        }).catch((err) => {
            console.log(err, "skfjnsdjkfn");
        })

        studentAcademicSchedule(contactId).then((res) => {
            console.log(res, "studentAcademicSchedule");
            let response = res.scheduleByDay;
            setScheduleData(response)
        }).catch((err) => {
            console.log(err, "skfjnsdjkfn");
        })
    }, []);


    useEffect(() => {
        const fetchGoals = async () => {
            setLoading(true);

            try {
                const userDetails = getUserDetails();
                const contactId = userType === "Student" ? userDetails?.ContactId : studentId

                if (!contactId) {
                    setLoading(false);
                    return;
                }

                const response = await getStudentGoalsAPI(contactId);
                console.log('MyGoals API Response:', response);

                if (response.success && Array.isArray(response.data?.myGoals)) {
                    setMyGoals(response.data.myGoals);
                } else {
                    setMyGoals([]);
                }
            } catch (err: any) {
                console.log('Error fetching my goals');
            } finally {
                setLoading(false);
            }
        };

        fetchGoals();
    }, []);



    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const;

    type DayOfWeek = typeof days[number];

    type ScheduleItem = {
        period: string;
        subject: string;
        room: string;
        startTime: string;
        endTime: string;
    };

    function splitDateTime(dateTimeString: any): { date: string | null; time: string | null } {
        const date = new Date(dateTimeString);

        if (isNaN(date.getTime())) {
            console.error("Invalid date format:", dateTimeString);
            return { date: null, time: null };
        }

        const formattedDate = date.toISOString().split('T')[0]; // e.g., "2025-06-26"
        const formattedTime = date.toTimeString().split(' ')[0]; // e.g., "06:30:00"

        return {
            date: formattedDate,
            time: formattedTime,
        };
    }

    const routeInfo = props?.data?.routeMapping?.[0]?.Route__r || {};
    const userStopId = props?.data?.routeMapping?.[0]?.Pickup_Point__c;
    const pickupList = props?.data?.pickup || [];
    function formatTo12HourTime(timeString: string): string {
        try {
            const date = new Date(`1970-01-01T${timeString}`);

            if (isNaN(date.getTime())) {
                throw new Error("Invalid time format");
            }

            return date.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
                timeZone: "UTC", // Important for Zulu (Z) time
            });
        } catch (error) {
            console.error("Time formatting error:", error);
            return "Invalid Time";
        }
    }

    const renderSchedule = () => {
        const currentSchedule = scheduleData[selectedDay] || [];

        if (loading) {
            return (
                <Box className={classes.scheduleContainer}>
                    <Box className={classes.dayTabs}>
                        {days.map((day) => (
                            <button
                                key={day}
                                className={`${classes.dayTab} ${selectedDay === day ? classes.activeDayTab : ''}`}
                                onClick={() => setSelectedDay(day)}
                            >
                                {day}
                            </button>
                        ))}
                    </Box>
                    <Box style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '200px',
                        color: '#64748B'
                    }}>
                        Loading schedule...
                    </Box>
                </Box>
            );
        }

        return (
            <Box className={classes.scheduleContainer}>
                <Box className={classes.dayTabs}>
                    {days.map((day) => (
                        <button
                            key={day}
                            className={`${classes.dayTab} ${selectedDay === day ? classes.activeDayTab : ''}`}
                            onClick={() => setSelectedDay(day)}
                        >
                            {day}
                        </button>
                    ))}
                </Box>

                {currentSchedule.length === 0 ? (
                    <Box style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '200px',
                        color: '#64748B',
                        border: '1px solid #E2E8F0',
                        borderRadius: '8px'
                    }}>
                        No classes scheduled for {selectedDay}
                    </Box>
                ) : (
                    <TableContainer sx={{ border: '1px solid #E2E8F0', borderRadius: '8px' }}>
                        <Table className={classes.scheduleTable} size="medium">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Period</TableCell>
                                    <TableCell>Subject</TableCell>
                                    <TableCell>Room no</TableCell>
                                    <TableCell>Start time</TableCell>
                                    <TableCell>End time</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {currentSchedule.map((item: any, index: number) => (
                                    <TableRow key={index} className={classes.scheduleRow}>
                                        <TableCell className={classes.periodCell}>{item.period}</TableCell>
                                        <TableCell className={classes.subjectCell}>{item.subject}</TableCell>
                                        <TableCell className={classes.roomCell}>{item.roomNo}</TableCell>
                                        <TableCell className={classes.timeCell}>{item.startTime}</TableCell>
                                        <TableCell className={classes.timeCell}>{item.endTime}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        );
    };

    function formatToLongDate(dateString: string): string {
        try {
            const parsedDate = new Date(dateString);

            if (isNaN(parsedDate.getTime())) {
                throw new Error("Invalid date format");
            }

            return parsedDate.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        } catch (error) {
            console.error("Date formatting error:", error);
            return "Invalid Date";
        }
    }
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleClick = () => {
      setOpenSnackbar(true);
    };
  
    const handleClosesnackbar = (event: Event | React.SyntheticEvent<any, Event>, reason?: SnackbarCloseReason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpenSnackbar(false);
    };
    return (
        <div>
            {
                loading && <KenLoader />
            }
            <Card className={classes.profileCard} sx={{ mt: 1 }}>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            orientation={isSmallScreen ? 'vertical' : 'horizontal'}
                            sx={{
                                padding: 0,
                                marginTop: '-10px',
                                '& .MuiTab-root': {
                                    fontSize: '13.5px',
                                    textTransform: 'capitalize',
                                    color: '#373A45',
                                    fontWeight: '400',
                                },
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#2C58E8',
                                },
                                '& .MuiTab-root.Mui-selected': {
                                    color: '#373A45',
                                    fontWeight: '500',
                                },
                            }}
                        >
                            <Tab label="Academic Plan" value={0} {...a11yProps(0)} />
                            <Tab label="Schedule" value={1} {...a11yProps(1)} />
                            <Tab label="Goals" value={2} {...a11yProps(2)} />
                            <Tab label="Health" value={3} {...a11yProps(3)} />
                            <Tab label="Wellness" value={4} {...a11yProps(4)} />
                            <Tab label="Extra Curriculars" value={5} {...a11yProps(5)} />
                            <Tab label="Achievements" value={6} {...a11yProps(6)} />
                            <Tab label="Conduct" value={7} {...a11yProps(7)} />
                            {
                                userType === "Student" ? <Tab label="Transportation" value={10} {...a11yProps(10)} /> :
                                    <Tab label="Attendance" value={8} {...a11yProps(8)} />
                            }
                            <Tab label="About me" value={9} {...a11yProps(9)} />
                        </Tabs>
                    </Box>

                    {/* CustomTabPanel Content */}
                    <CustomTabPanel value={value} index={0}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12} xl={3} lg={3} xxl={3}>
                                <Box className={`${classes.extraCuricularBox1} scrollbar-cusgray`}>
                                    <Stepper
                                        activeStep={activeStep}
                                        orientation="vertical"
                                        sx={{
                                            padding: 0,
                                            margin: 0,
                                            '& .MuiStep-root': {
                                                padding: 0,
                                                margin: 0,
                                            },
                                            '& .MuiStepLabel-root': {
                                                padding: 0,
                                                margin: 0,
                                            },
                                        }}
                                    >
                                        {data?.map((val: any, index: number) => (
                                            <Step key={val?.title}>
                                                <StepLabel>
                                                    <Box
                                                        className={classes.categoriesBox1}
                                                        onClick={() => {
                                                            setValueSemester(val)
                                                            handleSemesterData(val)
                                                            handleNext();
                                                        }}
                                                        sx={{ border: semesterValue == val?.groupName ? '1px solid #2C58E8' : '', padding: 0, margin: 0, marginTop: index !== 0 ? '-10px' : '' }}
                                                    >
                                                        <Typography className={classes.td}>{val?.groupName} ({`${val?.startYear} - ${val?.endYear}`})</Typography>
                                                    </Box>
                                                </StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} xl={9} lg={9} xxl={9} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                <div style={{ flex: 1, overflow: 'auto', marginTop: 10 }}>
                                    <table className={classes.table} style={{ border: '0.5px solid #ccc' }}>
                                        <thead>
                                            <tr className={classes.tableHeaderA}>
                                                {['Course', 'Q1', 'Q2', 'Q3', 'Q4', 'Final grade', 'GPA'].map((h, i) => (
                                                    <th key={i} className={classes.th}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {academicsData.length > 0 ? (
                                                academicsData.map((entry: any, i: number) => (
                                                    <tr key={i} className={classes.tableRowA}>
                                                        <td className={classes.td}>{entry.label}</td>
                                                        <td className={classes.td}>{entry.value.Q1 || '-'}</td>
                                                        <td className={classes.td}>{entry.value.Q2 || '-'}</td>
                                                        <td className={classes.td}>{entry.value.Q3 || '-'}</td>
                                                        <td className={classes.td}>{entry.value.Q4 || '-'}</td>
                                                        <td className={classes.td}>{entry.value.percentGrade ?? '-'}</td>
                                                        <td className={classes.td}>{entry.value.numericalGrade ?? '-'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7} style={{ textAlign: 'center', padding: '20px', color: '#999', fontSize: '12px' }}>
                                                        No academic data available.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, marginTop: 20 }}>
                                    <div className="d-flex gap-3">
                                        {academicsData?.[0]?.value?.credits && (
                                            <button
                                                style={{
                                                    padding: '6px 12px',
                                                    background: '#373A45',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: 4,
                                                    fontSize: 12,
                                                    marginRight: 8,
                                                }}
                                            >
                                                {`Total credits earned: ${academicsData[0].value.credits}`}
                                            </button>
                                        )}
                                        {academicsData?.[0]?.value?.GPA && (
                                            <button
                                                style={{
                                                    padding: '6px 12px',
                                                    background: '#373A45',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: 4,
                                                    fontSize: 12,
                                                }}
                                            >
                                                {`Cumulative GPA: ${academicsData[0].value.GPA}`}
                                            </button>
                                        )}
                                        <button style={{ padding: '6px 12px', background: '#FBEAEA', color: '#000', border: 'none', borderRadius: 4, fontSize: 12 }}>Overall status: <span style={{ color: '#D32F2F' }}>Needs improvement</span></button>
                                    </div>
                                    <>
      <button
        style={{
          padding: '6px 12px',
          background: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: 4,
          fontSize: 12,
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        Download Report Card
      </button>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleClosesnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleClosesnackbar} severity="info" variant="filled" sx={{ width: '100%' }}>
          Since this is test data, no reports are available for download at this time.
        </Alert>
      </Snackbar>
    </>
                                </div>
                            </Grid>

                        </Grid>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                        <Box
                            sx={{
                                height: '60vh',
                                '@media (min-width: 1920px) and (max-width: 1940px)': {
                                    height: '47.8vh',
                                },
                                '@media (min-width: 1536px) and (max-width: 1636px)': {
                                    height: '41vh !important',
                                },
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    height: '34.2vh !important',
                                },
                                '@media (min-width: 1440px) and (max-width: 1500px)': {
                                    height: '44.3vh !important',
                                },
                            }}
                            className="scrollbar-cusgray"
                        >
                            {renderSchedule()}
                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={2}>
                        <Box
                            sx={{
                                height: '60vh',
                                '@media (min-width: 1920px) and (max-width: 1940px)': {
                                    height: '54vh',
                                },
                                '@media (min-width: 1536px) and (max-width: 1636px)': {
                                    height: '49.3vh !important',
                                },
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    height: '43.7vh !important',
                                },
                                '@media (min-width: 1440px) and (max-width: 1500px)': {
                                    height: '52vh !important',
                                },
                            }}
                            className="scrollbar-cusgray"
                        >
                            <Grid container spacing={2}>

                                <Grid item md={10} >
                                    <Grid container spacing={2}>
                                        {myGoals.map((g, i) => (
                                            <Grid item md={5} xs={12}>
                                                <GoalCardStudent
                                                    Id={g.Id}
                                                    title={g.title ?? 'Untitled Goal'}
                                                    description={g.description ?? g.desc ?? 'No description'}
                                                    type={g.type ?? 'Unknown'}
                                                    progress={g.progress ?? { done: 0, total: 0 }}
                                                    assignedGoals="mygoals"
                                                    isOnlyFaculty={false} // Set according to your user role
                                                    isFaculty={false}
                                                    status={g.status}
                                                    profile={false}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                                <Grid item md={2}>
                                    <Button size="small" variant="contained" sx={{boxShadow:'none'}} className={classes.categoriesBtns} onClick={() => navigate("/goals/add-goals")}>
                                        + Add Goals
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                        <Box
                            sx={{
                                height: '60vh',
                                padding: '24px',
                                '@media (min-width: 1920px) and (max-width: 1940px)': {
                                    height: '54vh',
                                },
                                '@media (min-width: 1536px) and (max-width: 1636px)': {
                                    height: '49.3vh !important',
                                },
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    height: '43.7vh !important',
                                },
                                '@media (min-width: 1440px) and (max-width: 1500px)': {
                                    height: '52vh !important',
                                },
                            }}
                            className="scrollbar-cusgray"
                        >

                            <Grid container spacing={2}>
                                {props?.data?.health && props.data.health.length > 0 ? (
                                    props.data.health.map((item: any, index: number) => (
                                        <Grid item xs={12} key={index}>
                                            <Box className="d-flex justify-content-between align-items-center">
                                                <Box>
                                                    <Typography className={classes.profileBoxTitle}>
                                                        {item?.At_Risk_Conditions__c ?? 'N/A'}
                                                    </Typography>
                                                    <Typography className={classes.profileBoxContent}>
                                                        {item?.Emergency_Medication_On_File__c ?? 'N/A'}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Typography fontSize={"12px"}><Chip label={`Last Updated On : ${formatToLongDate(item?.LastModifiedDate ?? 'N/A')}` }></Chip></Typography>
                                                </Box>
                                            </Box>
                                            <hr
                                                style={{
                                                    border: "1px solid #E6E6E8",
                                                    marginTop: "5px",
                                                }}
                                            />
                                        </Grid>
                                    ))
                                ) : (
                                    <Grid item xs={12}>
                                        <Typography>No health data available.</Typography>
                                    </Grid>
                                )}
                            </Grid>

                        </Box>


                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={4}>
                        <Box
                            sx={{
                                height: '60vh',
                                '@media (min-width: 1920px) and (max-width: 1940px)': {
                                    height: '47.8vh',
                                },
                                '@media (min-width: 1536px) and (max-width: 1636px)': {
                                    height: '50vh !important',
                                },
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    height: '50.2vh !important',
                                },
                                '@media (min-width: 1440px) and (max-width: 1500px)': {
                                    height: '50.3vh !important',
                                },
                            }}
                            className="scrollbar-cusgray"
                        >

                            <Grid item xs={12} sm={12} md={12} xl={3} lg={3} xxl={3}>
                                <Typography className={classes.profileBoxTitle}>Mood Log</Typography>
                            </Grid>

                            <div style={{ overflow: 'auto', marginTop: '10px' }}>
                                <table className={classes.table}>
                                    <thead>
                                        <tr className={classes.tableHeader}>
                                            <th className={classes.th}>Date</th>
                                            <th className={classes.th}>Time</th>
                                            <th className={classes.th}>Mood</th>
                                            <th className={classes.th}>Feeling described</th>
                                            <th className={classes.th}>Impact Factor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props?.data?.wellness && props.data.wellness.length > 0 ? (
                                            props?.data?.wellness?.map((entry: any, index: number) => (
                                                <tr key={index} className={classes.tableRow1}>
                                                    <td className={classes.td}>{splitDateTime(entry.Date_Time__c).date}</td>
                                                    <td className={classes.td}>{splitDateTime(entry.Date_Time__c).time}</td>
                                                    <td className={classes.td}>
                                                        {entry.Logged_Feeling__c === 'Pleasant' ? (
                                                            <Chip size='small' label={entry.Logged_Feeling__c} sx={{ backgroundColor: '#C1DCC3', color: '#1F4E21' }} />
                                                        ) : entry.Logged_Feeling__c === 'Neutral' ? (
                                                            <Chip size='small' label={entry.Logged_Feeling__c} />
                                                        ) : (
                                                            <Chip size='small' label={entry.Logged_Feeling__c} sx={{ backgroundColor: '#FEEBBE', color: '#695113' }} />
                                                        )}
                                                    </td>
                                                    <td className={classes.td}>
                                                        <Typography >{entry?.Description__c}</Typography>
                                                    </td>
                                                    <td className={classes.td}>
                                                        <Typography>{entry?.Impact_Factor__c}</Typography>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5}>
                                                    <Typography align="center">No health data available.</Typography>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>


                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={5}>
                        <ExtraCurricular props={{ ...props, onDataUpdate: handleDataUpdate }} />
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={6}>
                        <Achievements props={{ ...props, onDataUpdate: handleDataUpdate }} />
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={7}>
                        <Box className={`${classes.extraCuricularBox2} scrollbar-cusgray`}>
                            <Typography className={classes.categoriesTitle}>Conduct</Typography>

                            {props?.data?.conduct && props.data.conduct.length > 0 ? (
                                props.data.conduct.map((item: any, index: number) => (
                                    <Box className={classes.clubsBox} key={index}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={9} sm={9} md={9} xl={10} lg={10} xxl={10}>
                                                <Typography className={classes.clubsTitle}>
                                                    {item?.hed__Role__c ?? 'No Role'}
                                                </Typography>

                                                <Typography className={classes.clubsContent} mt={2}>
                                                    {item?.hed__Description__c ?? 'No Description'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={3} sm={3} md={3} xl={2} lg={2} xxl={2}>
                                                <Box textAlign={'end'} mt={2}>
                                                    <Box display={"flex"} alignItems={"center"} justifyContent={"end"} gap={2}>
                                                        <CalendarTodayIcon sx={{ fontSize: '15px' }} />
                                                        <Typography fontSize={'12px'} fontWeight={'400'}>{formatToLongDate(item?.LastModifiedDate)}</Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))
                            ) : (
                                <Typography mt={2}>No conduct data available.</Typography>
                            )}

                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={8}>
                        <Box className={`${classes.extraCuricularBox} scrollbar-cusgray`} textAlign={'left'} padding={4}>
                            <Chip label={`Days Present : ${props?.data?.attendedDays}/${props?.data?.attendance} days`} size='small' />
                            <div style={{ overflow: 'auto', marginTop: '16px' }}>
                                <table className={classes.table}>
                                    <thead>
                                        <tr className={classes.tableHeader}>
                                            <th className={classes.th}>Date</th>
                                            <th className={classes.th}>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props?.data?.attendanceList?.map((entry: any, index: number) => (
                                            <tr key={index} className={classes.tableRow1}>
                                                <td className={classes.td}>{formatToLongDate(entry?.hed__Date__c)}</td>
                                                <td className={classes.td}>{
                                                    entry?.Attendance_Status__c === 'Present' ? (
                                                        <Chip size='small' label={entry.Attendance_Status__c} sx={{ backgroundColor: '#C1DCC3', color: '#1F4E21' }} />
                                                    ) : (
                                                        <Chip size='small' label={entry.Attendance_Status__c} sx={{ backgroundColor: '#FBEAEA', color: '#C02B2B' }} />
                                                    )
                                                }</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={10}>
                        <Grid container spacing={2}>
                            {/* Left Section - Pickup Table */}
                            <Grid item xs={9}>
                                <div style={{ overflow: 'auto', marginTop: '10px' }}>
                                    <table className={classes.table}>
                                        <thead>
                                            <tr className={classes.tableHeader}>
                                                <th className={classes.th}>Your stop</th>
                                                <th className={classes.th}>Stop name</th>
                                                <th className={classes.th}>Pick Time</th>
                                                <th className={classes.th}>Drop Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pickupList.length > 0 ? (
                                                pickupList.map((entry: any, index: number) => (
                                                    <tr key={index} className={classes.tableRow1}>
                                                        <td className={classes.td}>
                                                            {userStopId === entry?.Id && (
                                                                <Chip label="Your stop" sx={{ backgroundColor: '#BFCEFF' }} />
                                                            )}
                                                        </td>
                                                        <td className={classes.td}>{entry?.Name || '-'}</td>
                                                        <td className={classes.td}>
                                                            <Typography>
                                                                {formatTo12HourTime(entry?.Pickup_Time__c)}
                                                            </Typography>
                                                        </td>
                                                        <td className={classes.td}>
                                                            <Typography>
                                                                {formatTo12HourTime(entry?.Drop_Time__c)}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4}>
                                                        <Typography align="center">No Transportation Data Available</Typography>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Grid>

                            {/* Right Section - Driver Details */}
                            <Grid item xs={3}>
                                <Box textAlign="start" sx={{ backgroundColor: '#F6F8FB', borderRadius: '8px' }} p={2} mt={1}>
                                    <Typography fontSize="14px" fontWeight={500}>Driver Details</Typography>
                                    <Divider className='mt-2' />

                                    {[
                                        { label: "Bus number", value: routeInfo?.Vehicle_Number__c },
                                        { label: "Phone number", value: routeInfo?.Driver_Contact_number__c },
                                        { label: "License number", value: routeInfo?.License_Number__c },
                                        { label: "Vehicle number", value: routeInfo?.Vehicle_Number__c },
                                        { label: "Vehicle type", value: routeInfo?.Vehicle_Type__c },
                                    ].map((item, index) => (
                                        <Grid container spacing={2} key={index} className='mt-1'>
                                            <Grid item xs={6}>
                                                <Typography fontSize="12px">{item.label}:</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography fontSize="12px" fontWeight={500}>{item.value || '-'}</Typography>
                                            </Grid>
                                        </Grid>
                                    ))}

                                    {routeInfo?.Driver_Contact_number__c && (
                                        <div className='d-flex justify-content-center'>
                                            <a
                                                href={`tel:+${routeInfo.Driver_Contact_number__c}`}
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <Button className='mt-4 bg-dark text-white'>
                                                    <Typography fontSize="12px">Call driver</Typography>&nbsp;
                                                    <CallIcon fontSize="small" />
                                                </Button>
                                            </a>
                                        </div>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={9}>
                        <AboutMe props={{ props, onDataUpdate: handleDataUpdate }} />
                    </CustomTabPanel>
                </Box>
            </Card>
        </div>
    );
};

export default MyStudentTabPanel;




